import {$post, $get} from '../utils/request'


//查詢角色列表
export const $userList=async(params)=>{
    console.log("查询用户信息开始")
    console.log(params)
    let res=await $post('system/userList',params);
    console.log("查询用户信息结束")
    return res;
}



export const $submitUser= async(params)=>{
    console.log("提交用户信息开始")
    console.log(params)
    let res=await $post('system/submitUser',params);
    console.log(res)
    console.log("提交用户信息结束")
    return res;
}





export const $deleteUser= async(params)=>{
    let res=await $post('system/deleteUser',params);
    return res;
}


export const $getUser=async(params)=>{
    
    let res=await $post('system/getUser',params);
    return res;
}